<section class="sticky top-0 z-50 pb-4 z-10">
  <mat-toolbar class="shadow-md bg-gray-400 justify-center">
    <div
      class="w-full flex items-center justify-between"
      [class.max-w-7xl]="addExtraSpacing"
      [class.mx-auth]="addExtraSpacing"
      [class.px-4]="addExtraSpacing"
    >
      <div class="flex items-center">
        @if (showMenu) {
          @if (menuOpened) {
            <button matIconButton (click)="menuOpenedChange.emit(false)">
              <mat-icon>menu_open</mat-icon>
            </button>
          } @else {
            <button matIconButton (click)="menuOpenedChange.emit(true)">
              <mat-icon>menu</mat-icon>
            </button>
          }
        }
        <a href="/">
          <app-logo></app-logo>
        </a>
      </div>
      <nav class="space-x-4 text-sm flex justify-center">
        @if (showHomeNavigationRoutes) {
          <a href="#features" class="hover:underline">Features</a>
          <a href="#pricing" class="hover:underline">Pricing</a>
          <a href="#contact" class="hover:underline">Contact</a>
        }

        @if (isLoggedIn$()) {
          <button mat-flat-button (click)="openDashboard()">Dashboard</button>
          <button mat-button class="color-primary" (click)="logout()">
            Sign out
          </button>
        } @else {
          <button mat-flat-button (click)="login()">Login</button>
        }

        @if (isMd$()) {
          <button mat-icon-button [matMenuTriggerFor]="shortViewMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #shortViewMenu="matMenu">
            <a mat-menu-item href="/public/repository" class="color-primary">
              Repository
            </a>
            <a mat-menu-item href="/public/blogs" class="color-primary">
              Blogs
            </a>
            <button
              mat-menu-item
              [matMenuTriggerFor]="contactUsMenu"
              class="color-primary"
            >
              Contact Us
            </button>
            <mat-menu #contactUsMenu="matMenu">
              <p class="p-2" (click)="$event.stopPropagation()">
                Connect with us
                <span>
                  <span
                    (click)="copyEmail()"
                    class="text-[#008000] underline"
                    >{{ email }}</span
                  >
                  <mat-icon
                    (click)="copyEmail()"
                    class="text-base cursor-pointer color-primary align-middle"
                  >
                    content_copy
                  </mat-icon>
                </span>
              </p>
            </mat-menu>

            <button
              mat-menu-item
              [matMenuTriggerFor]="aboutUsMenu"
              class="color-primary"
            >
              About Us
            </button>
            <mat-menu #aboutUsMenu="matMenu">
              <a mat-menu-item href="/public/about-us">About Aimi</a>
              <a mat-menu-item href="/public/how-it-works">How It Works</a>
            </mat-menu>
            <button
              mat-menu-item
              [matMenuTriggerFor]="legalMenu"
              class="color-primary"
            >
              Legal
            </button>
            <mat-menu #legalMenu="matMenu">
              <a mat-menu-item href="/public/terms-of-service"
                >Terms Of Service</a
              >
              <a mat-menu-item href="/public/privacy-policy">Privacy Policy</a>
            </mat-menu>
          </mat-menu>
        } @else {
          <a matButton href="/public/repository" class="color-primary"
            >Repository</a
          >
          <a matButton href="/public/blogs" class="color-primary">Blogs</a>
          <button
            mat-button
            [matMenuTriggerFor]="contactUsMenu"
            class="color-primary"
          >
            Contact Us
          </button>
          <mat-menu #contactUsMenu="matMenu">
            <p class="p-2" (click)="$event.stopPropagation()">
              Connect with us
              <span>
                <span (click)="copyEmail()" class="text-[#008000] underline">{{
                  email
                }}</span>
                <mat-icon
                  (click)="copyEmail()"
                  class="text-base cursor-pointer color-primary align-middle"
                >
                  content_copy
                </mat-icon>
              </span>
            </p>
          </mat-menu>

          <button
            mat-button
            [matMenuTriggerFor]="aboutUsMenu"
            class="color-primary"
          >
            About Us
          </button>
          <mat-menu #aboutUsMenu="matMenu">
            <a mat-menu-item href="/public/about-us">About Aimi</a>
            <a mat-menu-item href="/public/how-it-works">How It Works</a>
          </mat-menu>

          <button
            matButton
            [matMenuTriggerFor]="legalMenu"
            class="color-primary"
          >
            Legal
          </button>
          <mat-menu #legalMenu="matMenu">
            <a mat-menu-item href="/public/terms-of-service"
              >Terms Of Service</a
            >
            <a mat-menu-item href="/public/privacy-policy">Privacy Policy</a>
          </mat-menu>
        }
      </nav>
    </div>
  </mat-toolbar>
  <div class="h-[8px]">
    @if (loading$()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
</section>
